module.exports = __webpack_public_path__ + "static/media/witch_wand.3b11b6fd.png";